
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  data() {
    return {
      links: this.$store.getters.orderedLinks,
      socialLinks: this.$store.getters.socialLinks,
    }
  },
  methods: {
    handleClick(link) {
      this.$store.dispatch('handle_link_click', link)
    },
  },
})
